// store/placementStore.js
import { create } from 'zustand';

const usePlacementStore = create((set, get) => ({
  previewPatterns: [],
  placementMode: false,
  showOnlySelected: false,
  selectedOnlyPCellName: "",

  selectedPatterns: [], // ✅ MULTI selection

  setShowOnlySelected: (value, cellName = "") =>
    set((state) => ({
      showOnlySelected: value,
      selectedOnlyPCellName: value
        ? (cellName || state.selectedOnlyPCellName)
        : "",
    })),

  setOnlyPreviewPattern: (patternName) =>
    set(() => ({
      previewPatterns: [{ name: patternName, placed: false }],
      placementMode: true,
    })),

  addPreviewPattern: (patternName) =>
    set((state) => {
      const alreadyExists = state.previewPatterns.some(p => p.name === patternName);
      if (alreadyExists) return state;
      return {
        previewPatterns: [...state.previewPatterns, { name: patternName, placed: false }],
        placementMode: true,
      };
    }),

  markAsPlaced: (patternName) =>
    set((state) => ({
      previewPatterns: state.previewPatterns.map((p) =>
        p.name === patternName ? { ...p, placed: true } : p
      ),
    })),

  removePattern: (patternName) =>
    set((state) => {
      const wasSelectedOnly = state.selectedOnlyPCellName === patternName;

      return {
        previewPatterns: state.previewPatterns.filter(
          (pattern) => pattern.name !== patternName
        ),
        selectedPatterns: state.selectedPatterns.filter(
          (name) => name !== patternName
        ),
        showOnlySelected: wasSelectedOnly ? false : state.showOnlySelected,
        selectedOnlyPCellName: wasSelectedOnly
          ? ""
          : state.selectedOnlyPCellName,
      };
    }),

  getPlacedPatterns: () =>
    get().previewPatterns.filter((p) => p.placed),

  togglePatternSelection: (patternName) =>
    set((state) => {
      const isSelected = state.selectedPatterns.includes(patternName);
      return {
        selectedPatterns: isSelected
          ? state.selectedPatterns.filter((name) => name !== patternName)
          : [...state.selectedPatterns, patternName],
      };
    }),

  setSelectedPatterns: (names) => set({ selectedPatterns: names }),
}));

export default usePlacementStore;
